export const createAddressChangeHandler = (
  getPredictions: (params: { input: string }) => void,
  resetPredictions: () => void,
) => {
  return (event: any) => {
    event.target.value.length >= 2
      ? getPredictions({
          input: event.target.value,
        })
      : resetPredictions();
  };
};
